import MediaNavTabs from '@/components/MediaNavTabs';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import symposiam from '/src/assets/symposiam.png';

const Exhibition = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'ทั้งหมด' },
    { id: 'main', name: 'นิทรรศการหลัก' },
    { id: 'creative', name: 'ผลงานสร้างสรรค์' },
    { id: 'live', name: 'นิทรรศการสด' },
  ];

  const exhibitionItems = [
    {
      id: 1,
      title: 'Main Exhibition: Lacquer Legacy',
      excerpt: 'นิทรรศการหลักที่แสดงประวัติศาสตร์และวิวัฒนาการของงานครั่งไทย',
      category: 'main',
      date: '15 มกราคม 2568',
      image: symposiam,
      featured: true,
      link: 'https://symposium.sacit.or.th/creative-works/lacquer-legacy',
      internal: false,
    },
    {
      id: 3,
      title: 'Live Exhibition (Demonstrative Area)',
      excerpt: 'พื้นที่สาธิตการทำงานศิลปหัตถกรรมไทยแบบสดๆ',
      category: 'live',
      date: '5 มกราคม 2568',
      image: '/cover/bannerlivex.JPG',
      link: '/live-exhibition',
      internal: true,
    },
  ];

  const filteredItems =
    activeCategory === 'all'
      ? exhibitionItems
      : exhibitionItems.filter((item) => item.category === activeCategory);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero + nav */}
      <div className="relative mt-16 sm:mt-20">
        <div
          className="w-full py-10 sm:py-16"
          style={{ background: 'linear-gradient(90deg, #BFB4EE 0%, #B3FFD1 100%)' }}
        >
          <div className="max-w-7xl mx-auto px-4">
            <h1
              className="text-center font-bold"
              style={{
                color: '#533192',
                fontFamily: 'Prompt',
                fontSize: 'clamp(1.6rem, 5vw, 3rem)',
              }}
            >
              สื่อและข่าวสาร
            </h1>
          </div>
        </div>
        <MediaNavTabs />
        <div className="w-full h-1.5" style={{ background: '#533193' }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 sm:py-12">
        <h2
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-6 sm:mb-8"
          style={{ fontFamily: 'Prompt', color: '#333' }}
        >
          นิทรรศการ
        </h2>

        {/* Category filter */}
        <div className="flex items-center gap-2 sm:gap-4 overflow-x-auto scrollbar-none mb-8 pb-1">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all ${
                activeCategory === cat.id
                  ? 'text-white shadow-md'
                  : 'bg-white text-gray-600 border border-gray-200 hover:border-purple-300'
              }`}
              style={
                activeCategory === cat.id
                  ? { background: 'linear-gradient(90deg, #533193, #8B7DC3)' }
                  : {}
              }
            >
              {cat.name}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {filteredItems.map((item, index) => {
            const cardContent = (
              <div className="relative rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 hover:scale-[1.02] hover:-translate-y-1">
                <div className="absolute inset-0">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-purple-900/80" />
                </div>
                <div className="relative h-[280px] sm:h-[360px] md:h-[420px] flex flex-col justify-end p-4 sm:p-5 md:p-6">
                  <div className="space-y-2 sm:space-y-3">
                    <div className="flex flex-wrap gap-2">
                      <span className="text-xs border border-white/60 text-white px-3 py-1 rounded-full">
                        นิทรรศการ
                      </span>
                      <span className="text-xs border border-white/60 text-white px-3 py-1 rounded-full">
                        {categories.find((cat) => cat.id === item.category)?.name}
                      </span>
                    </div>
                    <h3 className="text-base sm:text-lg md:text-xl font-bold text-white line-clamp-2" style={{ fontFamily: 'Prompt' }}>
                      {item.title}
                    </h3>
                    <p className="text-white/90 text-xs sm:text-sm line-clamp-2 sm:line-clamp-3" style={{ fontFamily: 'Prompt' }}>
                      {item.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-white/80 text-xs sm:text-sm" style={{ fontFamily: 'Prompt' }}>
                        {item.date}
                      </span>
                      <span className="w-9 h-9 sm:w-11 sm:h-11 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-700 transition-colors flex-shrink-0">
                        <span className="w-0 h-0 border-l-[6px] sm:border-l-[8px] border-l-white border-t-[4px] sm:border-t-[6px] border-t-transparent border-b-[4px] sm:border-b-[6px] border-b-transparent ml-0.5" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );

            return item.internal ? (
              <Link key={item.id} to={item.link} className="group w-full">
                {cardContent}
              </Link>
            ) : (
              <a
                key={item.id}
                href={item.link || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="group w-full"
              >
                {cardContent}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Exhibition;
